export default __webpack_public_path__ + "static/media/share_youtube.38edcf43.png";